import { default as TealiumUniversalTag } from "./lib/TealiumUniversalTag";
export default TealiumUniversalTag;
